import React from 'react';

//Override default OIDC callback components
export const CustomCallback = () => {

    return (<>
    </>);
}

export default CustomCallback;